export type ViewModelReference = string | { new(...params: unknown[]): object } | object;
